import _                       from 'underscore';
import React, { FC }           from 'react';
import { Header, Label, List } from 'semantic-ui-react';
import { Link }                from 'react-router-dom';

import { SystemAccountingQueries }                                      from '../../../../queries';
import { TimeService, UserService }                                     from '../../../../services';
import { useCurrentUser }                                               from '../../../../hooks';
import { RouterUtility }                                                from '../../../../util';
import { Flexbox, FlexItem, Page, PageTitleContainer, StyledContainer } from '../../../containers';
import { ListFromQuery, ListFromQueryItemProps }                        from '../../../components/from-query/ListFromQuery';
import { UserLink }                                                     from '../UserLink';
import { OrganizationUser }                                             from '../../../components/user/OrganizationUser';

import { CorvalProject, CorvalUserLike, FlexAlign, SemanticUIColor, Uuid } from '../../../../types';

interface UserProjectListingProps {
	accountId: Uuid,
	organizationId: Uuid
}

const defaultProps: UserProjectListingProps = {
	accountId:      null,
	organizationId: null,
}

const UserProjectListing: FC<UserProjectListingProps> = ( props ) => {
	
	let { currentUser }               = useCurrentUser(),
	    { accountId, organizationId } = props;
	
	const getProjectsCurrentUserShares = ( data: { projects: CorvalProject[] } ): Uuid[] => {
		
		return _.filter( data.projects, project => _.contains( _.pluck( project.projectMembers, 'accountId' ), accountId ) );
	}
	
	return (
		
		<ListFromQuery
			query={ SystemAccountingQueries.queries.GET_PROJECTS( `id name isActive assetName updatedUtc updatedById projectMembers { accountId }` ) }
			queryOptions={ {
				variables: {
					where: {
						organizationId:	{ eq: organizationId },
						id:				{ in: _.pluck(currentUser.projects, 'projectId') },
					}
				}
			} }
			queryResultObject={ getProjectsCurrentUserShares }
			containerComponent={ ( props: any ) => <List divided relaxed={ 'very' }>{ props.children }</List> }
			itemComponent={ ( props: ListFromQueryItemProps ) => {
				
				let { id, name, assetName, isActive } = props.item,
				    { updatedUtc, updatedById }       = props.item,
				    colorization                      = isActive ? SemanticUIColor.TEAL : SemanticUIColor.GREY;
				
				return (
					<List.Item>
						<Flexbox align={ FlexAlign.START }>
							<FlexItem basis={ 50 } className={ 'margin-md-right' }>
								<List className={ 'no-padding' }>
									<List.Item>
										<Header as={ 'h4' }>
											<Link to={ RouterUtility.getRoute( 'PROJECT.PLANNING', { projectId: id } ) }>{ name }</Link>
										</Header>
									</List.Item>
									<List.Item><strong>Project Asset:</strong> { assetName }</List.Item>
									<List.Item>
										<strong>Last Updated:</strong>
										{ ' ' }
										{ TimeService.ISOtoDisplayDate( updatedUtc, true ) }
										{ ' by ' }
										<OrganizationUser accountId={ updatedById } organizationId={ organizationId }>
											{ ( user: CorvalUserLike ) => <UserLink accountId={ updatedById } organizationId={ organizationId }>{ UserService.getUserName( user ) }</UserLink> }
										</OrganizationUser>
									</List.Item>
								</List>
							</FlexItem>
							<FlexItem noGrow>
								<Label content={ isActive ? 'Active' : 'Inactive' }
								       color={ colorization }
								       basic={ !isActive }
								/>
							</FlexItem>
						</Flexbox>
					</List.Item>
				)
			} }
		/>
	);
};

UserProjectListing.defaultProps = defaultProps;

export { UserProjectListing }
